import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

class HpmsMensagemCardApi extends ComponentAPI<{ nrSeqBeneficiario: number }> {

  @AwesomeEvent
  onSelect = new ClickEventListener();

}

export default HpmsMensagemCardApi;
